import Script from "next/script";
import React from "react";

const MarioLoader = () => {
    return (
        <>
            <Script
                src="https://unpkg.com/@dotlottie/player-component@latest/dist/dotlottie-player.mjs"
                type="module"
            ></Script>

            <dotlottie-player
                src="https://lottie.host/ed23d2bb-aa06-4a93-bdec-6883ca3bd39f/bAKqL31YxL.json"
                background="transparent"
                speed="1"
                style={{ width: "300px", height: "300px" }}
                loop
                autoplay
            ></dotlottie-player>
        </>
    );
};

export default MarioLoader;
